import { Form, Input } from 'antd';

import { REGEX_PINCODE_VALUE } from '../utils/Regexp/Regex';

import { InputInterface } from '../utils/forms/FormInterface';

import './style.scss';

interface PinCodeProps {
    formInput: InputInterface;
    index: number;
}

const PinCode = (props: PinCodeProps) => {
    const { formInput, index } = props;

    return (
        <Form.Item
            key={index}
            className='text'
            name={formInput.name}
            wrapperCol={{ span: 8, offset: 4 }}
            labelCol={{ span: 4 }}
            label={<div className={!formInput.required ? 'leftOffset' : ''}>{formInput.label}</div>}
            labelAlign='left'
            rules={[
                {
                    pattern: REGEX_PINCODE_VALUE,
                    message: 'Pincode must be a 6-digit number',
                },
                {
                    required: formInput.required,
                    message: formInput.errorMsg,
                },
            ]}>
            <Input
                style={{
                    width: '100%',
                }}
                value={[formInput.name]}
                disabled={formInput.readonly}
            />
        </Form.Item>
    );
};

export default PinCode;
